import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import RaisedButton from 'material-ui/RaisedButton'
import NotificationToggle from './NotificationToggle'
import LogoutIcon from '../assets/LogoutIcon'
import UserPassword from './UserPassword'
import PracticeLocations from './PracticeLocation'
import tokenStorage from '../../services/token-storage'
import css from './styles.css'

const styles = {
  logoutButton: {
    position: 'absolute',
    top: '20px',
    right: '0px',
    width: '100px',
  },
  logoutIcon: {
    position: 'relative',
    width: '15px',
    height: '15px',
    marginRight: '5px',
    top: '2px',
  },
}

const logoutIcon = <LogoutIcon fill={'white'} styles={styles.logoutIcon} />

const reloadPageAndClearState = () => window.location.reload()

class Account extends Component {
  static propTypes = {
    hasDSO: PropTypes.bool.isRequired,
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
    isPracticeAdmin: PropTypes.bool.isRequired,
    hasReminders: PropTypes.bool.isRequired,
    username: PropTypes.string.isRequired,
  }
  handleLogout = () => {
    tokenStorage.clear()
    reloadPageAndClearState()
    this.props.history.push('/login')
  }

  render() {
    const { hasDSO, isPracticeAdmin, username, hasReminders } = this.props
    return (
      <div className={css.wrapper}>
        <div className={css.header}>
          <h2>Account</h2>
          <NotificationToggle />
          <RaisedButton
            style={styles.logoutButton}
            label="LOGOUT"
            backgroundColor={'#333333'}
            labelPosition="before"
            labelColor={'white'}
            icon={logoutIcon}
            onClick={this.handleLogout}
          />
          <hr className={css.rule} />
        </div>
        <div className={css.main}>
          <UserPassword username={username} />
          <PracticeLocations
            hasDSO={hasDSO}
            hasReminders={hasReminders}
            isPracticeAdmin={isPracticeAdmin}
          />
        </div>
        <div className={css.footer}>
          <h2>Support</h2>
          <hr className={css.rule} />
          <p>
            Need help updating your location information? Get in touch with us!
          </p>
          <p>requests@roostergrin.com</p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: { hasDSO, hasReminders },
    user: { username, isPracticeAdmin },
  },
}) => ({
  hasDSO,
  isPracticeAdmin,
  username,
  hasReminders,
})

export default connect(mapStateToProps)(Account)



// WEBPACK FOOTER //
// ./src/components/Account/index.js